import React, { useState } from "react";
import { Typography, TextField, Button, Box } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function CardPin({ systemData, loginUser }) {
    /** CREDENTIALS */
    const [inputValue, setInputValue] = useState('');
    const [numeros] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, <ArrowBackIcon className='btn-mui-large fs-1' />, 0, <CheckIcon className='btn-mui-large fs-1' />]);

    const handleNumberPress = (number) => {
        if (!isNaN(number) && inputValue.length <= 5)
            setInputValue(inputValue + number)
        else if (number.type === ArrowBackIcon) {
            handleDelete();
        } else if (number.type === CheckIcon) {
            handleSubmit();
        }
    };

    const handleSubmit = async () => loginUser('', inputValue, 'PIN')

    const handleDelete = () => setInputValue(inputValue.slice(0, -1));

    function NumPad() {
        const buttonClass = 'col-3'
        return (
            <Box className="d-flex justify-content-center col-12">
                <div className="col-9 mx-auto">
                    {numeros.reduce((rows, numero, index) => {
                        if (index % 3 === 0) rows.push([]);
                        rows[rows.length - 1].push(numero);
                        return rows;
                    }, []).map((row, rowIndex) => (
                        <div className="col-12 d-flex justify-content-between my-4" key={rowIndex}>
                            {row.map((numero, index) => {
                                const btnClass = !isNaN(numero) ?
                                    `btn-numeric-pin ${buttonClass}` :
                                    numero.type === CheckIcon ?
                                        `btn-accept-pin ${buttonClass}` :
                                        `btn-back-pin ${buttonClass}`;
                                return (
                                    <Button className={btnClass} key={index} onClick={() => handleNumberPress(numero)}>
                                        {numero}
                                    </Button>
                                )
                            })}
                        </div>
                    ))}
                </div>
            </Box>
        )
    }

    const textInputProps = {
        maxLength: 6,
        className: "textfield-pin text-center"
    }

    return (
        <Box className="custom-card-pin col-lg-7 col-md-9 col-sm-10 col-11 kiwox-panel shadow d-flex flex-column align-items-center">
            <div className="py-4">
                <img src={systemData.entry_logo} alt="report-automator" />
            </div>
            {/* ------------------------------ START TEXTO EN LOGIN EDITABLE ------------------------------ */}
            <Typography className="fs-1 mb-3 login-title">{systemData.login_title}</Typography>
            {/* ------------------------------ END TEXTO EN LOGIN EDITABLE ------------------------------ */}
            <form className="box-form" onSubmit={handleSubmit}>
                <div className="col-9">
                    <TextField
                        className="w-100"
                        required
                        id="inputValue"
                        name="inputValue"
                        autoFocus
                        value={inputValue}
                        type="password"
                        inputProps={textInputProps}
                        onChange={(event) => {
                            const re = /^[0-9\b]+$/;
                            if (event.target.value === '' || re.test(event.target.value))
                                setInputValue(event.target.value)
                        }}
                    />
                </div>
                <NumPad />
            </form>
        </Box>
    )
}

export default CardPin;